import React, { Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import ApplicationLayout from "layouts/application";
import MainLayout from "layouts/main";
import ActionHistory from "pages/action-history";
import Home from "pages/home";
import Login from "pages/login";
import OCR from "pages/ocr";
import ReadPassport from "pages/read-passport";
import Result from "pages/result";
import Scoring from "pages/scoring";
import Settings from "pages/settings";
import Users from "pages/users";
import request from "request";
import { useDispatch, useSelector } from "store/hooks";
import { useAuth } from "utils/useAuth";
import { ProtectedRoute } from "protectedRoute";

export type AuthStatus = "checking" | "authenticated" | "unauthenticated";


interface RoleGuardProps {
  allowed: boolean;
  children: React.ReactElement;
}

const AppRoutes: React.FC = (): JSX.Element => {
  const location = useLocation();
  const user = useSelector((state) => state.user);

  const isLoginRoute = location.pathname === "/login";
  const token = localStorage.getItem("token");
  const authStatus = useAuth(isLoginRoute);

  const isPending =
    authStatus === "checking" ||
    (!isLoginRoute && Boolean(token) && authStatus === "unauthenticated");

  return (
    <Suspense fallback="Loading">
      <Routes>
        <Route
          path="/login"
          element={
            authStatus === "authenticated"
              ? <Navigate to="/" replace />
              : <Login />
          }
        />

        <Route
          path="/"
          element={<ProtectedRoute authStatus={authStatus} isPending={isPending} />}
        >
          <Route index element={<Home />} />

          <Route path="/application" element={<ApplicationLayout />}>
            <Route path="/application/:id/ocr/pkb" element={<OCR />} />
            <Route path="/application/:id/scoring" element={<Scoring />} />
            <Route path="/application/:id/result" element={<Result />} />
          </Route>

          <Route path="/read-passport" element={<ReadPassport />} />

          <Route
            path="/settings"
            element={user.role !== "USER" ? <Settings /> : <></>}
          />
          <Route
            path="/action-history"
            element={user.role !== "USER" ? <ActionHistory /> : <></>}
          />
          <Route
            path="/users"
            element={user.role !== "USER" ? <Users /> : <></>}
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;